import { render } from "./ProcedureStep.vue?vue&type=template&id=6269630b&scoped=true"
import script from "./ProcedureStep.vue?vue&type=script&lang=js"
export * from "./ProcedureStep.vue?vue&type=script&lang=js"

import "./ProcedureStep.vue?vue&type=style&index=0&id=6269630b&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6269630b"]])

export default __exports__